module.exports = __webpack_public_path__ + "img/XPA.77ef6204.svg";